export default class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.accordion');

        this.ready();
    }

    ready() {
        this.accordions.forEach((accordion) => {
            const perguntas = accordion.querySelectorAll('.pergunta');
            perguntas.forEach((pergunta) => {
                pergunta.querySelector('.titulo').addEventListener('click', () => {
                    pergunta.classList.toggle('active');
                });
            });
        });
    }
}
if (document.querySelector('.accordion')) {
    new Accordion();
}
